export default __webpack_public_path__ + "static/media/templateClose.88899f27.svg";